const externalLinks = {
    SKS_TWITTER_URL: 'https://twitter.com/SwitchKickApps',
    SKS_INSTAGRAM_URL: 'https://www.instagram.com/switchkickstudios/'
}

export default externalLinks;